import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Organization } from 'data/terra/Organization';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import TerraBff from 'services/apis/terraBff/TerraBff';
import { RootState } from 'store/reducer';
import { OrganizationsState } from '../reducer';

enum ActionTypes {
  loadInit = 'organizations/loadInit',
  loadInitSuccess = 'organizations/loadInitSuccess',
  loadInitFailure = 'organizations/loadInitFailure',
}

export interface FetchOrganizationsAction {
  type: ActionTypes;
  organizations: Organization[];
  error?: string;
}

export const fetchOrganizations = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  dispatch({ type: ActionTypes.loadInit });
  const result = await TerraBff.organization.fetchOrganizations();
  if (result.isSuccess()) {
    dispatch({
      type: ActionTypes.loadInitSuccess,
      organizations: result.get()?.data ?? [],
    } as FetchOrganizationsAction);
  } else {
    dispatch({
      type: ActionTypes.loadInitFailure,
      error: result.exception().message,
    } as FetchOrganizationsAction);
  }

  return result;
};

export const fetchOrganizationsDelegate: DelegateMapEntry<
  FetchOrganizationsAction,
  OrganizationsState
> = {
  [ActionTypes.loadInit]: (
    state: OrganizationsState,
    action: FetchOrganizationsAction
  ): OrganizationsState => {
    return {
      ...state,
      organizations: [],
      hasInitialized: false,
      isLoadingInit: true,
      error: undefined,
    };
  },
  [ActionTypes.loadInitSuccess]: (
    state: OrganizationsState,
    action: FetchOrganizationsAction
  ): OrganizationsState => {
    return {
      ...state,
      organizations: action.organizations,
      hasInitialized: true,
      isLoadingInit: false,
    };
  },
  [ActionTypes.loadInitFailure]: (
    state: OrganizationsState,
    action: FetchOrganizationsAction
  ): OrganizationsState => {
    return {
      ...state,
      isLoadingInit: false,
      error: action.error,
    };
  },
};
